
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

type ApprovalType = 'approve_only' | 'approve_and_confirm';

@Component
export default class ApprovalDialog extends Vue {
  @Prop({ type: Boolean, required: true }) readonly value!: boolean;
  @Prop({ type: Number, required: true }) readonly itemCount!: number;
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  @Prop({ type: Number, default: 1 }) readonly poCount!: number;
  @Prop({ type: Object, default: null }) readonly singlePo!: any;

  notes = '';
  confirmationStep = false;
  selectedApprovalType: ApprovalType | null = null;

  get dialog(): boolean {
    return this.value;
  }

  set dialog(value: boolean) {
    this.$emit('input', value);
  }

  get dialogTitle(): string {
    if (!this.confirmationStep) {
      return 'Confirm Approval';
    }
    return this.selectedApprovalType === 'approve_only'
      ? 'Confirm: Approve as Draft'
      : 'Confirm: Approve as Confirmed';
  }

  @Watch('value')
  onDialogChange(newVal: boolean) {
    if (!newVal) {
      // Reset state when dialog closes
      this.notes = '';
      this.confirmationStep = false;
      this.selectedApprovalType = null;
    }
  }

  handleCancel() {
    if (this.confirmationStep) {
      // Go back to step 1
      this.confirmationStep = false;
      this.selectedApprovalType = null;
    } else {
      // Close dialog
      this.dialog = false;
      this.$emit('cancel');
    }
  }

  // US-037: Select approval type and show confirmation
  selectApprovalType(type: ApprovalType) {
    this.selectedApprovalType = type;
    this.confirmationStep = true;
  }

  // US-037: Confirm the selected approval type
  confirmApproval() {
    this.$emit('confirm', {
      notes: this.notes,
      approvalType: this.selectedApprovalType
    });
  }
}
